import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { VisibleContext } from './context';
import { useNullableMediaQuery } from './use-nullable-media-query';
export function VisibleProvider(props) {
    const isMdAndUp = useNullableMediaQuery('md');
    const isLgAndUp = useNullableMediaQuery('lg');
    const isXlAndUp = useNullableMediaQuery('xl');
    return (_jsx(VisibleContext.Provider, { value: {
            isMdAndUp,
            isLgAndUp,
            isXlAndUp,
        }, children: props.children }));
}
